"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module Model/Messaging
 */
var MessagingError;
(function (MessagingError) {
    MessagingError["query_execution_failed"] = "query_execution_failed";
    MessagingError["api_connection_failed"] = "api_connection_failed";
    MessagingError["transaction_broadcast_failed"] = "transaction_broadcast_failed";
    MessagingError["account_does_not_exist"] = "account_does_not_exist";
    MessagingError["message_decryption_failed"] = "message_decryption_failed";
    MessagingError["syntactic_error"] = "syntactic_error";
    MessagingError["invalid_parameters"] = "invalid_parameters";
})(MessagingError = exports.MessagingError || (exports.MessagingError = {}));
var DCoreMessagePayload = /** @class */ (function () {
    function DCoreMessagePayload() {
        this.id = '';
        this.created = '';
        this.sender = '';
        this.sender_pubkey = '';
        this.text = '';
    }
    return DCoreMessagePayload;
}());
exports.DCoreMessagePayload = DCoreMessagePayload;
var CustomOperationSubtype;
(function (CustomOperationSubtype) {
    CustomOperationSubtype[CustomOperationSubtype["undefined"] = 0] = "undefined";
    CustomOperationSubtype[CustomOperationSubtype["messaging"] = 1] = "messaging";
    CustomOperationSubtype[CustomOperationSubtype["max"] = 2] = "max";
})(CustomOperationSubtype = exports.CustomOperationSubtype || (exports.CustomOperationSubtype = {}));
//# sourceMappingURL=messaging.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/model/messaging.js
// module id = 353
// module chunks = 0